var modules_ef1f9f15 = {"tabs":"_snm8lf","wrap":"_r24gmp","panes":"_1q3t6te","tab":"_1vxtsor","view-text":"_13lxiz5","color-gray":"_wuz7g7","color-light":"_11qi2gw","active":"_7sw081","color-dark":"_jv8r25","pane":"_1udono1"};
import "../../../assets/BcQd2rIY.css";

export { modules_ef1f9f15 as default };
//# sourceMappingURL=Tabs.module.less.js.map
